import React, { useState, useEffect } from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
// import { actionTypes, useStateValue } from "./../../../store";
import { Link } from "react-router-dom";
import BtnCompare from "../../Product/BtnCompare";
import BtnWishList from "../../Product/BtnWishList";

const NewArrivalProductGridBox = ({ itemin }) => {
    console.log("itemin",itemin)
    // const [{ token, huid, wishlistitemcount, wishListArrayID, compareitemcount, msgalert }, dispatch] = useStateValue();

    return (
        <>
            <div className="product-card product-card--layout--grid d-flex bg-white position-relative rounded">
                {/* <div className="product-card__actions-list d-flex flex-column">
                            {itemin?.price <= 0 ? <>
                            </> : <>
                                <BtnWishList pid={itemin?.productId} btntype={'icon'} />
                            </>}
                            <BtnCompare pid={itemin?.productId} btntype={'icon'} pname={itemin?.name} entryText={itemin?.shortDescription} pimage={itemin?.image} catid={itemin?.mainCatId} />
                        </div> */}
                <div className="product-card__image">
                    <div className="image image--type--product">
                        {/* <Link className="image__body" to={`/product-detail/${itemin?.slug}`}>
                            <img alt="" className="image__tag" src={itemin?.image} />
                        </Link> */}
                        <a  href={itemin.type === "ecom" ? `/product-detail/${itemin?.slug}` : `/oem-category/${itemin?.catSlug}/${itemin?.SubCatSlug}/${itemin?.slug}`} className="image__body">
                            <img alt="" className="image__tag" src={itemin?.image} />
                        </a>
                    </div>
                </div>
                <div className="product-card__info">
                    <div>
                        <div className="d-flex align-items-center mb-2 me-3 justify-content-end">
                            {itemin?.price <= 0 ? (
                                <></>
                            ) : (
                                <>
                                    <BtnWishList pid={itemin?.productId} btntype={"icon"} />
                                </>
                            )}
                            <BtnCompare
                                pid={itemin?.productId}
                                btntype={"icon"}
                                pname={itemin?.name}
                                entryText={itemin?.shortDescription}
                                pimage={itemin?.image}
                                catid={itemin?.mainCatId}
                            />
                        </div>
                    </div>
                    <div className="product-card__meta d-none">
                        <span className="product-card__meta-title">{itemin?.catLabel}</span>
                    </div>
                    <div className="product-card__name">
                        {/* <Link to={`/product-detail/${itemin?.slug}`} className='fw-bold f14'>{itemin?.name}</Link> */}
                        <a href={itemin.type === "ecom" ? `/product-detail/${itemin?.slug}` : `/oem-category/${itemin?.catSlug}/${itemin?.SubCatSlug}/${itemin?.slug}`} className="fw-bold f14">
                            {itemin?.name}
                        </a>
                    </div>
                    <div className={itemin?.price <= 0 ? "product-card__desc_new_arrival" : "product-card__desc"}>{itemin?.shortDescription}</div>
                </div>
                <div className="product-card__footer">
                    {itemin?.price <= 0 ? (
                        <div className="new-product_div_withoutprice">

                        </div>
                    ) : (
                        <>
                            <div className="product-card__prices">
                                <div className="new_arrival_price gap-1 d-flex align-items-center">
                                    <div>MRP:</div>
                                    <div className="d-flex align-items-center gap-1">
                                        <span>
                                            ₹
                                        </span>
                                        {itemin?.price}
                                    </div>
                                </div>
                            </div>

                            <a
                                href={itemin.type === "ecom" ? `/product-detail/${itemin?.slug}` : `/oem-category/${itemin?.catSlug}/${itemin?.SubCatSlug}/${itemin?.slug}`}
                                className="btn btn-sm border HoverBgRed addtocartbtn buynowbtntext txtdgray mb-1 mt-2"
                            >
                                Buy Now
                            </a>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default NewArrivalProductGridBox;
